import { Navigate, useSearchParams } from "react-router-dom";
import { ROTA_DOS_CEDENTES, ROTA_DOS_CONVENIOS } from "@/rotas";

/*
 * `/beneficiarios`: link salvo e histórico de quem já operava antes do rótulo
 * "Cedentes", como `/sistemas` para `/aplicacoes`. `?aba=convenios` continua valendo, e
 * `?aba=pessoas` é a lista, que abre sem parâmetro. `replace` para o voltar não cair num
 * laço.
 */
export function RedirecionarBeneficiarios() {
  const [parametros] = useSearchParams();
  const destino = parametros.get("aba") === "convenios" ? ROTA_DOS_CONVENIOS : ROTA_DOS_CEDENTES;

  return <Navigate to={destino} replace />;
}
